"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const rebass_1 = require("rebass");
const styled_components_1 = __importDefault(require("styled-components"));
const react_light_state_1 = __importDefault(require("react-light-state"));
const OnePointSDKBase_1 = require("../../OnePointSDKBase");
const store = new react_light_state_1.default({ apps: [] }, "apps", {
    storageName: "fozg-apps",
});
function default_1() {
    const apps = store.useStore((state) => state.apps);
    react_1.useEffect(() => {
        fetch();
    }, []);
    const fetch = () => __awaiter(this, void 0, void 0, function* () {
        const res = yield OnePointSDKBase_1.OPSDK.getAppByName("fozg-elements")
            .getListByName("apps")
            .getItems();
        if (!res.isError) {
            store.setState({ apps: res.data });
        }
    });
    return (react_1.default.createElement(rebass_1.Box, { width: 360 },
        react_1.default.createElement(rebass_1.Box, { ml: 15 },
            react_1.default.createElement(rebass_1.Text, { fontWeight: 500, fontSize: 15 }, "More apps")),
        react_1.default.createElement(rebass_1.Flex, { flexWrap: "wrap", padding: 10 }, apps.map((app) => (react_1.default.createElement(AppItem, { href: app.url, target: "_blank" },
            react_1.default.createElement(Image, { src: app.image_url }),
            react_1.default.createElement(rebass_1.Text, { fontWeight: 500, ml: 2, fontSize: ".85em" }, app.title)))))));
}
exports.default = default_1;
const Image = styled_components_1.default.img `
    max-width: 40px;
    height: 40px;
`;
const AppItem = styled_components_1.default.a `
    padding: 10px;
    display: flex;
    // flex-direction: column;
    align-items: center;
    // justify-content: center;
    text-align: center;
    width: 50%;
    box-sizing: border-box;
    border-radius: 10px;
    text-decoration: none;
    :visited {
        color: #000;
    }
    :hover {
        cursor: pointer;
        box-shadow: 0 0px 0px 2px rgba(100, 100, 100, 0.25);
        background: rgba(0, 0, 0, 0.1);
    }
`;
//# sourceMappingURL=AppLists.js.map